import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22AppLayoutClient.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../../../public/fonts/theFuture/TheFuture-Regular.woff2%22,%22weight%22:%22400%22},{%22path%22:%22../../../../public/fonts/theFuture/TheFuture-Medium.woff2%22,%22weight%22:%22500%22},{%22path%22:%22../../../../public/fonts/theFuture/TheFuture-Black.woff2%22,%22weight%22:%22700%22}],%22variable%22:%22--font-the-future%22,%22display%22:%22swap%22,%22preload%22:true}],%22variableName%22:%22TheFuture%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'TheFuture', 'TheFuture Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
